export default "<div id=\"mainApp\">\n  <router-outlet></router-outlet>\n</div>\n"